import Vue from 'vue'
Vue.config.devtools = true;

// dependecies
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyBFAaY0-YgkpA_N7ijYkthQihbggHvYkac',
		libraries: 'places',
	},
})
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
Vue.component('GmapCluster', GmapCluster)

// import carousel from 'v-owl-carousel'
// Vue.component('carousel', carousel);

import VueI18n from 'vue-i18n'
Vue.use(VueI18n);

import messages from '@/i18n';

console.log(messages);
const i18n = new VueI18n({
	locale: 'de', // set locale
	messages,
});

import VeeValidate from 'vee-validate';
import validationMessages from 'vee-validate/dist/locale/en';
import validationMessagesDE from 'vee-validate/dist/locale/de';
Vue.use(VeeValidate, {
	i18nRootKey: 'validations',
	i18n,
	dictionary: {
		en: validationMessages,
		de: validationMessagesDE
	}



});

import { Validator } from 'vee-validate';

// import dictionary from '@/dict';

Validator.localize(messages);




/* eslint-disable no-new */
console.log('%c' + 'Linienflug Design ✈ Weil bewegt bewegt.', 'line-height: 30px; font-size: 18px; border-radius: .25em;background-color: #2b3846; color: #ffa300; padding: 3px .5em;');
import App from './App';
import './components/Forms'
import './components/Generals'
import './components/Modules'
import router from './router'


import VueApi from '@/VueApi'
Vue.use(VueApi);
import store from '@/store';


window.app = new Vue({
	el: '#app',
	router,
	store,
	i18n,
	components: { App },
	template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js